/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Accordion } from "react-bootstrap";
import Globals from "../../shared/Globals";
import BaseCom from "../BaseCom";
import L from "../Lang";
import FormBuilder from "./Form/FormBuilder";
import FormDataModal from "../FormDataModal";
import { EditorGlobal } from "../Editor";

export default class Form extends BaseCom {

    async componentDidMount() { 
        await this.fillListAsync('/api/form/fieldtype/list', 'fieldTypes');
    }

    getFieldType = (id) => {
        return this.state.fieldTypes?.find(i => i.id === parseInt(id));
    }
    
    properties(col, state, changeStateValue, onChange) {
        return (<>
            <FormBuilder
                col={col}
                show={state.showFormBuilder}
                onHide={() => {
                    changeStateValue('showFormBuilder', false);
                    changeStateValue('initialProps', null);
                }}
                onSubmit={() => {
                    changeStateValue('showFormBuilder', false);
                    onChange();
                }}
                initialProps={state.initialProps}
                />
            <FormDataModal
                col={col}
                show={state.showFormData}
                siteDomainID={EditorGlobal.siteDomainID}
                onHide={() => {
                    changeStateValue('showFormData', false);
                }}
                />
            <Accordion.Item eventKey="-1">
                <Accordion.Header><L>Form</L></Accordion.Header>
                <Accordion.Body>
                    <div className="d-flex gap-1 justify-content-evenly">
                        <button type="button" className="btn btn-primary d-block" onClick={() => {
                            changeStateValue('showFormBuilder', true);
                            changeStateValue('initialProps', col.extendedProps);
                        }}>
                            <L>Form Builder</L>
                        </button>
                        <button type="button" className="btn btn-secondary d-block" onClick={() => {
                            changeStateValue('showFormData', true);
                        }}>
                            <L>View Data</L>
                        </button>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            </>
        );
    }

    render() {
        let view = null;
        if(this.props.col.extendedProps?.views)
            view = this.props.col.extendedProps.views[0];
        return (
            <div className={'text-center p-4 bg-light ' + this.props.col.className}
                style={Globals.preprocessStyleObject(this.props.col.style)}>

                <h4>{view?.name}</h4>

                {view && view.fields?.map((i, idx) => (
                    <div className="form-group mb-3">
                        <label className="form-label">{i.name}</label>
                        {this.getFieldType(i.fieldType)?.htmlElement === 'select' ? <select key={idx} className="form-control"></select>
                            : this.getFieldType(i.fieldType)?.htmlElement === 'textarea' ? <textarea key={idx} className="form-control"></textarea>
                            : <input key={idx} type={this.getFieldType(i.fieldType)?.htmlElementType} className="form-control" />}
                    </div>
                ))}

                {this.props.col.extendedProps?.views?.length > 0 && 
                    <div className="d-grid">
                    <button type="button" className="btn btn-primary">{this.props.col.extendedProps?.views.length > 1 ? 'Continue' : 'Submit'}</button>
                </div>}
                
            </div>
        );
    }
}